interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

const SinglePageIcon = ({ width = 34, height = 27, color = '#000000' }: Properties) => {
  return (
    <svg
      fill={color}
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 100 100'
      enable-background='new 0 0 100 100'
    >
      <g>
        <path
          d='M80.277,12.498h-0.005v-4.02c0-0.956-0.774-1.73-1.73-1.73h-2.45v0H47.402v0h-1.73l-25.95,25.95v2.447v1.013v52.912v2.447
		c0,0.956,0.774,1.73,1.73,1.73h1.582H76.96h1.582c0.956,0,1.73-0.774,1.73-1.73v-2.448h0.005L80.277,12.498z M29.679,83.292V36.158
		h17.723c0.956,0,1.73-0.774,1.73-1.73V16.705h21.188l0,66.587H29.679z'
        />
      </g>
    </svg>
  );
};

export default SinglePageIcon;
